import { render } from "./QuestQuizDetails.vue?vue&type=template&id=372a714a&scoped=true"
import script from "./QuestQuizDetails.vue?vue&type=script&lang=js"
export * from "./QuestQuizDetails.vue?vue&type=script&lang=js"

import "./QuestQuizDetails.vue?vue&type=style&index=0&id=372a714a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372a714a"]])

export default __exports__